<div @show class="body main-component" [formGroup]="formGroup">

    <div class="left-column">

        <div class="notification-list">

            <mat-form-field class="width" appearance="fill">
                <mat-label>Produkte filtern</mat-label>
                <input matInput formControlName="filter" autocomplete="off" />
                <button mat-icon-button color="warn" (click)="filterControl.setValue(null)" matSuffix>
                    <mat-icon>clear</mat-icon>
                </button>
            </mat-form-field>

            <div class="product-preview" [class.active]="!currentProduct" (click)="createNew()">

                Neu anlegen
    
            </div>
    
            <ng-container *ngFor="let product of (products|productFilter:filterControl.value)">
    
                <div class="product-preview" (click)="setProduct(product)" [class.active]="currentProduct === product">
    
                    <span class="text">{{product.productid|product|async}}</span>
                    <mat-icon class="icon" color="warn" (click)="deleteProduct(product, $event)">delete_forever</mat-icon>
    
                </div>
    
            </ng-container>

        </div>

        <div class="footer">

            <button mat-raised-button color="primary" (click)="save()" [disabled]="productControl.pristine">
                {{currentProduct? 'Speichern': 'Anlegen'}}
            </button>

        </div>

    </div>

    <div class="content">

        <app-product-form formGroupName="product"></app-product-form>

        <app-product-pictures></app-product-pictures>

    </div>

</div>
